import { http } from "../http-common";

const getSeasonRegistration = (year, config = {}) => {
    return http.get(
      `/season-registration?cropYearList=${year}`,config
    );
  };

const getCropYears = (config) => {
    return http.get(`/cropYears`, config);
  };


const CropSeasonListService = {
    getCropYears,
    getSeasonRegistration
};
  
export default CropSeasonListService;